import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../api/client';
import type { AdminPlan } from '../../types';

export function PlansPage() {
  const [plans, setPlans] = useState<AdminPlan[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function reload() {
    try {
      setPlans(await api<AdminPlan[]>('/api/admin/plans'));
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load plans');
    }
  }
  useEffect(() => { void reload(); }, []);

  async function onDelete(id: string, name: string) {
    if (!confirm(`Delete plan "${name}"? Users on this plan will fall back to no plan.`)) return;
    try {
      await api(`/api/admin/plans/${id}`, { method: 'DELETE' });
      await reload();
    } catch (err) {
      alert(err instanceof Error ? err.message : 'Failed to delete');
    }
  }

  return (
    <section className="admin-page">
      <header className="admin-page-header">
        <h1>Plans</h1>
        <Link to="/admin/plans/new" className="btn-primary">New plan</Link>
      </header>
      {error && <div className="form-error" role="alert">{error}</div>}
      {!plans && !error && <p style={{ color: 'var(--text-muted)' }}>Loading…</p>}
      {plans && (
        <table className="admin-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Slug</th>
              <th>Billing</th>
              <th>Price</th>
              <th>Categories</th>
              <th>Users</th>
              <th>Active</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {plans.map((p) => (
              <tr key={p.id}>
                <td>{p.name}</td>
                <td><code>{p.slug}</code></td>
                <td>{p.billingType}</td>
                <td>{p.billingType === 'free' ? '—' : `$${(p.priceCents / 100).toFixed(2)}`}</td>
                <td>{p.categories.length}</td>
                <td>{p.userCount}</td>
                <td>{p.isActive ? '✓' : '—'}</td>
                <td className="admin-table-actions">
                  <Link to={`/admin/plans/${p.id}`} className="btn-link">Edit</Link>
                  <button type="button" className="btn-link" onClick={() => void onDelete(p.id, p.name)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
